import { useState, useEffect } from "react";
import {
    DataGridPremium,
} from "@mui/x-data-grid-premium";
import { useNavigate } from "react-router";
import classes from "../../Clan.module.css";
import { toast } from "react-toastify";
import AUTH_CONTEXT from "../../../../store";
import Loader from "../../../../components/Loader/Loader";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import { BASE_PATH_TO_HOME, BASE_PATH_TO_USER_DETAILS } from "../../../../base_routes_paths/data_paths";
import CustomToolbar from "../../../../components/toolbar";
import { ClansServices } from "../../../../services/clan_services";
import { BASE_PATH_TO_CLAN_CHATS_LIST } from "../../../../base_routes_paths/clans_paths";

const AllClansList = () => {
    const userColumns = [
        {
            field: "Name",
            headerName: "Name",
            width: 150,
        },
        {
            field: "ClanIconLink",
            headerName: "ClanIconLink",
            width: 100,
            renderCell: (params) => {
                return (
                    <div className={classes.cellWithImg}>
                        <img
                            className={classes.cellImg}
                            src={params.row.ClanIconLink || "https://areno.in/img/group-1@2x.svg"}
                            alt=""
                        />
                    </div>
                );
            },
        },
        {
            field: "ClanCaptain",
            headerName: "ClanCaptain",
            width: 230,
            renderCell: (params) => {
                return (
                    <a target="_blank" rel="noreferrer" href={`${BASE_PATH_TO_USER_DETAILS}/` + params.row.ClanCaptain}>{params.row.ClanCaptain}</a>
                );
            },
        },
        {
            field: "ClanViceCaptain",
            headerName: "ClanViceCaptain",
            width: 230,
            renderCell: (params) => {
                return (
                    <a target="_blank" rel="noreferrer" href={`${BASE_PATH_TO_USER_DETAILS}/` + params.row.ClanViceCaptain}>{params.row.ClanViceCaptain}</a>
                );
            },
        },
        {
            field: "Badges",
            headerName: "Badges",
            width: 80,
        },
        {
            field: "IsClosedForRequests",
            headerName: "IsClosedForRequests",
            width: 150,
        },
        {
            field: "PointsEarned",
            headerName: "PointsEarned",
            width: 120,
        },
        {
            field: "Country",
            headerName: "Country",
            width: 120,
        },
        {
            field: "CountryName",
            headerName: "CountryName",
            width: 180,
        },
        {
            field: "IsActive",
            headerName: "IsAcive",
            width: 100,
        },
        {
            field: "Descriptions",
            headerName: "Descriptions",
            width: 300,
        },
    ];

    const { token, fileName } = AUTH_CONTEXT();
    const EXPORT_FILENAME = `${fileName}_ClansList`;
    const [isDataFetched, setIsDataFetched] = useState(false);
    const [data, setData] = useState([]);
    const navigate = useNavigate()

    const FetchApi = async () => {
        try {
            let response = await ClansServices.getAllClans(token, navigate, null);
            if (response.status === 207) {
                return toast
                    .error(response.error, {
                        position: "bottom-left",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: false,
                        progress: undefined,
                        theme: "light",
                    })
            }
            let result = response.data;
            let input = result.map(({ _id: id, ...result }) => ({
                id,
                ...result,
            }));
            setData(input);
            setIsDataFetched(true);
            toast.success("Data fetched successfully!!", {
                position: "bottom-left",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        } catch (e) {
            setIsDataFetched(false);
            toast.error(e, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    };

    useEffect(() => {
        if (!isDataFetched) {
            FetchApi();
        }
    }, []);

    const actionColumn = [
        {
            field: "action",
            headerName: "Action",
            width: 200,
            renderCell: (params) => {
                return (
                    <div className={classes.cellAction}>
                        <div>
                            <Link
                                href={`${BASE_PATH_TO_CLAN_CHATS_LIST}/` + params.row.id}
                                style={{ textDecoration: "none" }}
                            >
                                <div className={classes.viewButton}>View Clan Chats</div>
                            </Link>
                        </div>
                    </div>
                );
            },
        },
    ];

    return (
        <div>
            {isDataFetched && (
                <div className={classes.datatable}>
                    <Breadcrumbs aria-label="breadcrumb" sx={{ marginBottom: 1 }}>
                        <Link underline="hover" color="inherit" href={BASE_PATH_TO_HOME}>
                            Dashboard
                        </Link>
                        <Typography color="text.primary">
                            Clan
                        </Typography>
                        <Typography color="text.primary">Clans List</Typography>
                    </Breadcrumbs>
                    <DataGridPremium
                        rows={data}
                        columns={userColumns.concat(actionColumn)}
                        slots={{
                            toolbar: () => (
                                <CustomToolbar
                                    EXPORT_FILENAME={EXPORT_FILENAME}
                                    // onClickCreate={() => {
                                    //     navigate(BASE_PATH_TO_ADD_POINT_PURCHASE_VOUCHERS);
                                    // }}
                                    displayCreate={"none"}
                                    onClickUpdate={() => { }}
                                    displayUpdate={"none"}
                                />
                            ),
                        }}
                        pagination
                        initialState={{
                            pagination: {
                                paginationModel: { pageSize: 25, page: 0 },
                            },
                        }}
                        disableRowSelectionOnClick
                        checkboxSelection
                    />
                </div>
            )}
            {!isDataFetched && <Loader />}
        </div>
    );
};

export default AllClansList;
